import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CheckName } from "../types/incidentbanner.typer";
import { incidentBannerApi } from "../api/incidentbanner.api";
import { useTranslation } from "react-i18next";

export const useIncidentBanner = (): {
  isApplicationHealthy: boolean | undefined;
  unhealthyServicesList: CheckName[] | undefined;
  manualBannerText: string | null;
  invalidateIncidentBannerQuery: () => Promise<void>;
  isLoading: boolean;
} => {
  const { data, isLoading } = useQuery({
    queryKey: ["incidentBanner"],
    queryFn: () => incidentBannerApi.hentIncidentBanner(),
    throwOnError: true,
  });
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  const language = i18n.language;
  const fallbackLng = "nb";

  let manualText: string | null = null;
  if (
    data?.manualBannerText !== undefined &&
    Object.keys(data.manualBannerText).includes(language) &&
    data.manualBannerText[language] !== null
  )
    manualText = data.manualBannerText[language];
  else if (
    data !== undefined &&
    Object.keys(data.manualBannerText).includes(fallbackLng) &&
    data.manualBannerText[fallbackLng] !== null
  )
    manualText = data.manualBannerText[fallbackLng];

  return {
    isApplicationHealthy: data?.isApplicationHealthy,
    unhealthyServicesList: data?.unhealthyServicesList,
    manualBannerText: manualText,
    invalidateIncidentBannerQuery: () =>
      queryClient.invalidateQueries({
        queryKey: ["incidentBanner"],
      }),
    isLoading: isLoading,
  };
};
